import { useState } from "react";
import { useNavigate } from "react-router";
import { login } from "../api/auth";
import { ApiError } from "../api/client";

export function LoginScreen() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!email || !password || loading) return;
    setLoading(true);
    setError(null);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/");
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "Couldn't sign in.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4">
      <div className="w-full max-w-sm rounded-xl border border-border bg-surface p-8">
        <div className="mb-6 text-center">
          <h1 className="text-[22px] font-bold">
            Prep<span className="text-accent">AI</span>
          </h1>
          <p className="mt-1 text-[13px] text-text-muted">Worker Dashboard</p>
        </div>

        {error ? (
          <p className="mb-4 rounded-lg bg-negative/10 px-3 py-2 text-[13px] text-negative">
            {error}
          </p>
        ) : null}

        <div className="flex flex-col gap-4">
          <div>
            <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wider text-text-muted">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && void submit()}
              placeholder="you@prepai.education"
              className="w-full rounded-lg border border-border bg-bg px-3 py-2.5 text-[14px] text-text outline-none placeholder:text-text-muted focus:border-accent"
            />
          </div>
          <div>
            <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wider text-text-muted">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && void submit()}
              className="w-full rounded-lg border border-border bg-bg px-3 py-2.5 text-[14px] text-text outline-none placeholder:text-text-muted focus:border-accent"
            />
          </div>
          <button
            type="button"
            disabled={loading}
            onClick={() => void submit()}
            className="mt-2 rounded-lg bg-accent px-4 py-2.5 text-[14px] font-semibold text-bg transition-colors hover:bg-accent-light disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </div>
      </div>
    </div>
  );
}
